<template>
  <div>
    <v-dialog v-model="model" max-width="400" scrollable persistent>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>Adicionar Serviço</v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <div class="detalhes-servico">
                  <span>Título</span><br/>
                  <label class="max-label">{{ dadosGerais.titulo }}</label>
                </div>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <div class="detalhes-servico">
                  <span>Descrição</span><br/>
                  <label class="max-label-line">{{ dadosGerais.descricao }}</label>
                </div>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <v-textarea
                    v-model="dadosGerais.observacao"
                    name="observacao"
                    placeholder="Adicione uma observação"
                    filled
                    auto-grow
                    counter="300"
                    maxlength="300"
                    v-validate="{required: false, min: 5, max: 300}"
                    :error-messages="errors.collect('observacao')">
                  <template v-slot:label>Observação</template>
                </v-textarea>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <v-text-field
                    v-model="dadosGerais.quantidade"
                    name="quantidade"
                    placeholder="Informe a quantidade"
                    type="number"
                    v-validate="{required: true}"
                    :error-messages="errors.collect('quantidade')">
                  <template v-slot:label>
                    Quantidade <span class="ml-1 red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <input-valor
                    v-model="dadosGerais.valor"
                    label="Valor"
                    placeholder="Informe o valor do serviço"
                    hideDetails
                    :event-submit="'blur'"
                    :prefix="prefixo"
                    :suffix="sufixo"
                    :precision="casasDecimais"
                    @blur="(valor) => dadosGerais.valor = valor"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>

          <v-spacer/>
          <v-btn @click="fecharModal" outlined>Voltar</v-btn>
          <v-btn @click="cadastrarServico" depressed class="primary ml-5">Cadastrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import InputValor from '@/views/components/InputValor.vue'
import {actionTypes} from '@/core/constants'
import _ from 'lodash'

export default {
    name: 'ServicoAtendimentoCadastroModal',
    components: {InputValor},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        servico: {
            type: Object,
            required: true
        },
        atendimentoId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            dadosGerais: {
                observacao: null,
                quantidade: null,
                valor: null
            },
            prefixo: 'R$',
            sufixo: '',
            casasDecimais: 2,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    beforeMount() {
        this.setarDadosIniciais()
    },
    methods: {
        setarDadosIniciais() {
            this.dadosGerais = _.cloneDeep(this.servico)
            this.dadosGerais.quantidade = 1
        },
        async cadastrarServico() {
            if (await this.validarDadosFormulario()) {

                const input = {
                    atendimentoId: this.atendimentoId,
                    servicoId: this.dadosGerais.id,
                    observacao: this.dadosGerais.observacao,
                    quantidade: this.dadosGerais.quantidade,
                    valor: this.dadosGerais.valor
                }

                this.setMensagemLoading('Adicionando serviço...')
                await this.$store.dispatch(actionTypes.SERVICO_ATENDIMENTO.CADASTRAR_SERVICO, input)
                this.mostrarNotificacaoSucessoDefault()
                this.fecharModalCadastro()
            }
        },
        async validarDadosFormulario() {
            return this.$validator._base.validateAll()
        },
        fecharModal() {
            this.model = false
            this.$emit('fecharModalCadastrarServicoAtendimento')
        },
        fecharModalCadastro() {
            this.model = false
            this.$emit('fecharModalCadastroServicoAtendimento')
        }
    }
}
</script>

<style scoped lang="stylus">

.detalhes-servico
  padding 10px 5px 10px 5px
  border-radius 5px

  span
    font-weight bold
    color var(--theme-primary)

.max-label
  display inline-block
  max-width 300px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.max-label-line
  display -webkit-box
  max-width 300px
  overflow hidden
  text-overflow ellipsis
  -webkit-box-orient vertical
  -webkit-line-clamp 4


</style>